// Google Ads (gtag.js) consent bridge + event helper.
// The tag itself loads once in public/index.html with Consent Mode v2 defaults (denied).
export const GOOGLE_ADS_ID = "AW-18419233780";
export const CONSENT_KEY = "zejzen_cookie_ok";

const DENIED = {
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
  analytics_storage: "denied",
};

const GRANTED = {
  ad_storage: "granted",
  ad_user_data: "granted",
  ad_personalization: "granted",
  analytics_storage: "granted",
};

export function acceptGoogleConsent() {
  localStorage.setItem(CONSENT_KEY, "accepted");
  window.gtag?.("consent", "update", GRANTED);
}

export function declineGoogleConsent() {
  localStorage.setItem(CONSENT_KEY, "declined");
  window.gtag?.("consent", "update", DENIED);
}

export function trackGoogleAdsEvent(name, params = {}) {
  window.gtag?.("event", name, { ...params, send_to: GOOGLE_ADS_ID });
}

// --- Dynamic remarketing / ecommerce events (product IDs must match the Merchant Center feed) ---
const retailItem = (p) => ({ id: p.id || p._id, google_business_vertical: "retail" });

export function trackViewItem(product) {
  if (!product) return;
  trackGoogleAdsEvent("view_item", {
    value: Number(product.price) || 0,
    currency: "EUR",
    items: [retailItem(product)],
  });
}

export function trackAddToCart(product) {
  if (!product) return;
  trackGoogleAdsEvent("add_to_cart", {
    value: Number(product.price) || 0,
    currency: "EUR",
    items: [retailItem(product)],
  });
}

export function trackBeginCheckout(items, total) {
  trackGoogleAdsEvent("begin_checkout", {
    value: Number(total) || 0,
    currency: "EUR",
    items: (items || []).map((i) => retailItem(i.product || i)),
  });
}

// Fires the purchase conversion once the user creates a "Purchase" conversion action
// in Google Ads and the label is configured (backend env GOOGLE_ADS_CONVERSION_LABEL).
export function trackPurchaseConversion({ conversionLabel, value, transactionId, items }) {
  if (!conversionLabel || !window.gtag) return;
  window.gtag("event", "conversion", {
    send_to: conversionLabel,
    value: Number(value) || 0,
    currency: "EUR",
    transaction_id: transactionId,
    items: (items || []).map((i) => retailItem(i)),
  });
}
